import { j as r } from "./atoms-v218.js";
import { Fragment as x } from "react";
import { Column as t } from "./atoms-v212.js";
import { Grid as p } from "./atoms-v216.js";
const d = 4, g = ({
  cards: m,
  gridProps: a,
  id: o,
  isSkeleton: i,
  numberOfSkeletonCards: n,
  skeletonCard: s
}) => /* @__PURE__ */ r.jsx(p, { ...a, children: i ? /* @__PURE__ */ r.jsx(x, { children: Array.from({ length: n ?? d }).map(
  (l, e) => /* @__PURE__ */ r.jsx(t, { large: 4, max: 7, medium: 8, small: 4, xLarge: 7, children: s }, `${o}-skeleton-${e}`)
) }) : m == null ? void 0 : m.map((l, e) => /* @__PURE__ */ r.jsx(t, { large: 4, max: 7, medium: 8, small: 4, xLarge: 7, children: l }, `${o}-card-${e}`)) });
g.displayName = "Blocks.CardList";
export {
  g as CardList
};
